module.exports = __webpack_public_path__ + "img/price-quote8.b0aff002.png";